import { createReducer } from '@reduxjs/toolkit' ;
import { getonboardingmerchantsInfoRequest, getonboardingmerchantsInfoSuccess, getonboardingmerchantsInfoFailure } from '../../actions/adminFlow/onboardingmerchantsInfoAction';

const initialState = {
	
	onboardingmerchantsInfoLoading: false,
	onboardingmerchantsInfoRow: {},
	onboardingmerchantsInfoRowError: '',
	
}

const onboardingmerchantsInfoReducer = createReducer(initialState, (builder) => {
    builder
	.addCase(getonboardingmerchantsInfoRequest, (state) => { 
		state.onboardingmerchantsInfoLoading = true;
	}).addCase(getonboardingmerchantsInfoSuccess, (state, action) => {
		state.onboardingmerchantsInfoLoading = false;
		state.onboardingmerchantsInfoRow = action.payload.data;
		state.onboardingmerchantsInfoRowError = '';
	}).addCase(getonboardingmerchantsInfoFailure, (state, action) => {
		state.onboardingmerchantsInfoLoading = false;
		state.onboardingmerchantsInfoRow = null;
		state.onboardingmerchantsInfoRowError = action.payload.error;
	}).addDefaultCase(() => { });
});
export default onboardingmerchantsInfoReducer;
